<div role="tabpanel" class="tab-pane active" id="loading">
  <div class="loading">
      <div class="loading-containner">
          <img src="./../../../../assets/images/loading.gif" alt="Carregando">

      </div>
      <div class="animated-words">
          <span>Consultando Dados...</span>
          <span>Realizando Simulação...</span>
          <span>Verificando Valores...</span>
          <span>Checando Dados...</span>
          <span>Verificando o Sistema...</span>
          <span>Aguardando Resposta...</span>
      </div>
  </div>
</div>

<app-modal-message #modalMessage [title]="'Atenção!'" [hideClose]="true"></app-modal-message>
